import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";
import { userDataType } from "../../../stores/accountManagementStore";

export default async function registerAccount(
    email: string,
    password: string
): Promise<userDataType> {
    if (!email || !password || email.length < 3 || password.length < 5) {
        toast.error("Invalid email or password");
        return null;
    }

    const signUpPromise = async () => {
        const { data, error } = await supabase.auth.signUp({
            email,
            password,
        });

        if (error) {
            if (error.message === "User already registered") {
                throw new Error("An account with this email already exists");
            }
            if (error.message === "Invalid login credentials") {
                throw new Error("Invalid email or password");
            }
            if (error.message && error.message.includes("Password")) {
                throw new Error(error.message);
            }
            throw new Error(error.message);
        }

        // if (!data.user || !data.session) {
        //     throw new Error("Failed to create account");
        // }

        const userData: userDataType = {
            id: data.user.id,
            email: data.user.email || "",
            providers: data.user.app_metadata?.providers || []
        };

        return userData;
    };

    try {
        const result = await toast.promise(
            signUpPromise(),
            {
                pending: "Creating account...",
                success: "Account created! Please check your email to verify",
                error: "Failed to create account",
            }
        );
        return result;
    } catch (err) {
        console.log("Create account error:", err);
        return null;
    }
}
